"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var VideoPlayerElement_1 = __importDefault(require("./VideoPlayerElement"));
var classnames_1 = __importDefault(require("classnames"));
var maxWidths = {
    '1': '100%',
    '2': '50%',
    '3': '50%',
    '4': '50%',
    '5': '33.333%',
};
var VideoPlayerViewGrid = function (_a) {
    var sources = _a.sources, labels = _a.labels, videoListener = _a.videoListener, mainVideoRef = _a.mainVideoRef, overlay = _a.overlay, children = _a.children;
    var maxWidth = maxWidths[sources.length.toString()];
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(sources.length > 1 ? "ui-video-player-view-grid" : "ui-video-player-view-single") },
        overlay,
        sources.map(function (source, i) { return (react_1.default.createElement(VideoPlayerElement_1.default, { style: { maxWidth: maxWidth }, videoListener: videoListener, key: source + '-' + (labels ? labels[i] : ''), source: source, label: labels ? labels[i] : undefined, videoRef: i === 0 ? mainVideoRef : undefined }, i === 0 ? children : undefined)); })));
};
exports.default = VideoPlayerViewGrid;
